// 차트 종류별 템플릿과 예시 데이터 정의

export const chartCategories = {
  basic: {
    label: '기본 차트',
    charts: ['bar', 'multi_bar', 'line', 'pie']
  },
  // 복합 차트 - 숨김 처리
  // composite: {
  //   label: '복합 차트',
  //   charts: ['dual_axis_line', 'stacked_bar']
  // },
  advanced: {
    label: '고급 차트',
    charts: ['table']
  },
  special: {
    label: '특수 차트',
    charts: ['badge', 'webframe']
  }
};

export const chartTemplates = {
  bar: {
    name: '싱글 바 차트',
    icon: '📊',
    description: '카테고리별 값을 비교하는 기본 차트',
    template: {
      title: '월별 에너지 사용량',
      description: '월별 에너지 사용량을 막대 그래프로 표시합니다. 각 월의 사용량을 한눈에 비교할 수 있습니다.',
      chart_options: {
        viz_type: 'bar',
        showFrame: true,
        transparent: false,
        options: {
          axes: {
            x: '월',
            y: '사용량 (kWh)'
          },
          style: {
            colors: ['#5470c6', '#91cc75', '#fac858']
          },
          advanced: {
            showDataLabels: false,
            labelFormat: '{value}',
            labelPosition: 'top'
          }
        }
      },
      data_source: {
        type: 'sql',
        query: `SELECT month, usage 
FROM (
  VALUES 
    ('1월', 320),
    ('2월', 332),
    ('3월', 301),
    ('4월', 334),
    ('5월', 390),
    ('6월', 330)
) AS t(month, usage)`
      },
      data_result: {
        categories: ['1월', '2월', '3월', '4월', '5월', '6월'],
        series: [{
          name: '사용량',
          values: [320, 332, 301, 334, 390, 330]
        }]
      },
      updateInterval: 3600
    }
  },

  // 멀티 바 차트 (그룹형 막대 차트)
  multi_bar: {
    name: '멀티 바 차트',
    icon: '📊',
    description: '여러 시리즈를 그룹으로 비교하는 막대 차트',
    template: {
      title: '요일별 층별 전력 사용량 (그룹 막대)',
      description: '여러 시리즈(예: 층)를 요일별로 그룹 막대로 비교합니다.',
      chart_options: {
        viz_type: 'bar',
        showFrame: true,
        transparent: false,
        options: {
          axes: {
            x: '요일',
            y: '전력 사용량 (kWh)'
          },
          style: {
            colors: ['#5470c6', '#91cc75', '#fac858', '#ee6666']
          },
          advanced: {
            showLegend: true,
            legendPosition: 'top',
            horizontal: false,
            showDataLabels: false,
            labelFormat: '{value}',
            labelPosition: 'top'
          }
        }
      },
      data_source: {
        type: 'sql',
        query: `SELECT day_of_week, series_name, value 
FROM (
  SELECT 'Mon' as day_of_week, '1층' as series_name, 320 as value
  UNION ALL SELECT 'Mon', '2층', 280
  UNION ALL SELECT 'Mon', '3층', 350
  UNION ALL SELECT 'Tue', '1층', 332
  UNION ALL SELECT 'Tue', '2층', 295
  UNION ALL SELECT 'Tue', '3층', 368
  UNION ALL SELECT 'Wed', '1층', 301
  UNION ALL SELECT 'Wed', '2층', 267
  UNION ALL SELECT 'Wed', '3층', 345
  UNION ALL SELECT 'Thu', '1층', 334
  UNION ALL SELECT 'Thu', '2층', 298
  UNION ALL SELECT 'Thu', '3층', 380
  UNION ALL SELECT 'Fri', '1층', 390
  UNION ALL SELECT 'Fri', '2층', 345
  UNION ALL SELECT 'Fri', '3층', 412
  UNION ALL SELECT 'Sat', '1층', 330
  UNION ALL SELECT 'Sat', '2층', 290
  UNION ALL SELECT 'Sat', '3층', 365
  UNION ALL SELECT 'Sun', '1층', 320
  UNION ALL SELECT 'Sun', '2층', 275
  UNION ALL SELECT 'Sun', '3층', 340
) AS t
ORDER BY 
  CASE day_of_week 
    WHEN 'Mon' THEN 1
    WHEN 'Tue' THEN 2
    WHEN 'Wed' THEN 3
    WHEN 'Thu' THEN 4
    WHEN 'Fri' THEN 5
    WHEN 'Sat' THEN 6
    WHEN 'Sun' THEN 7
  END, series_name`
      },
      data_result: {
        categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        series: [
          { name: '1층', values: [320, 332, 301, 334, 390, 330, 320] },
          { name: '2층', values: [280, 295, 267, 298, 345, 290, 275] },
          { name: '3층', values: [350, 368, 345, 380, 412, 365, 340] }
        ]
      },
      updateInterval: 3600
    }
  },
  
  line: {
    name: '싱글 라인 차트',
    icon: '📈',
    description: '단일 데이터의 시간별 추세를 보여주는 차트',
    template: {
      title: '일별 SOC 변화',
      description: '일주일간 배터리 충전 상태(SOC) 변화를 라인 차트로 표시합니다.',
      chart_options: {
        viz_type: 'line',
        showFrame: true,
        transparent: false,
        options: {
          axes: {
            x: '날짜',
            y: 'SOC (%)'
          },
          style: {
            colors: ['#91cc75']
          },
          advanced: {
            yMin: null,
            yMax: null,
            showDataLabels: false,
            labelFormat: '{value}{unit}',
            labelPosition: 'top'
          }
        }
      },
      data_source: {
        type: 'sql',
        query: `SELECT day, soc 
FROM (
  VALUES 
    ('Mon', 82),
    ('Tue', 75),
    ('Wed', 68),
    ('Thu', 85),
    ('Fri', 92),
    ('Sat', 88),
    ('Sun', 79)
) AS t(day, soc)`
      },
      data_result: {
        categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        series: [{
          name: 'SOC',
          values: [82, 75, 68, 85, 92, 88, 79]
        }]
      },
      updateInterval: 3600
    }
  },
  
  multi_line: {
    name: '멀티 라인 차트',
    icon: '📊',
    description: '여러 데이터를 비교하며 추세를 보여주는 차트',
    template: {
      title: '요일별 전력 사용량 비교',
      description: '층별 전력 사용량을 요일별로 비교합니다. 여러 데이터를 동시에 추적할 수 있습니다.',
      chart_options: {
        viz_type: 'line',
        showFrame: true,
        transparent: false,
        options: {
          axes: {
            x: '요일',
            y: '전력 사용량 (kWh)'
          },
          style: {
            colors: ['#5470c6', '#91cc75', '#fac858', '#ee6666']
          },
          advanced: {
            showLegend: true,
            legendPosition: 'top',
            lineSmooth: true,
            showDataLabels: false,
            labelFormat: '{value}',
            labelPosition: 'top'
          }
        }
      },
      data_source: {
        type: 'sql',
        query: `SELECT day_of_week, series_name, power_usage 
FROM (
  SELECT 'Mon' as day_of_week, '1층' as series_name, 320 as power_usage
  UNION ALL SELECT 'Mon', '2층', 280
  UNION ALL SELECT 'Mon', '3층', 350
  UNION ALL SELECT 'Tue', '1층', 332
  UNION ALL SELECT 'Tue', '2층', 295
  UNION ALL SELECT 'Tue', '3층', 368
  UNION ALL SELECT 'Wed', '1층', 301
  UNION ALL SELECT 'Wed', '2층', 267
  UNION ALL SELECT 'Wed', '3층', 345
  UNION ALL SELECT 'Thu', '1층', 334
  UNION ALL SELECT 'Thu', '2층', 298
  UNION ALL SELECT 'Thu', '3층', 380
  UNION ALL SELECT 'Fri', '1층', 390
  UNION ALL SELECT 'Fri', '2층', 345
  UNION ALL SELECT 'Fri', '3층', 412
  UNION ALL SELECT 'Sat', '1층', 330
  UNION ALL SELECT 'Sat', '2층', 290
  UNION ALL SELECT 'Sat', '3층', 365
  UNION ALL SELECT 'Sun', '1층', 320
  UNION ALL SELECT 'Sun', '2층', 275
  UNION ALL SELECT 'Sun', '3층', 340
) AS t
ORDER BY 
  CASE day_of_week 
    WHEN 'Mon' THEN 1
    WHEN 'Tue' THEN 2
    WHEN 'Wed' THEN 3
    WHEN 'Thu' THEN 4
    WHEN 'Fri' THEN 5
    WHEN 'Sat' THEN 6
    WHEN 'Sun' THEN 7
  END, series_name`
      },
      data_result: {
        categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        series: [
          {
            name: '1층',
            values: [320, 332, 301, 334, 390, 330, 320]
          },
          {
            name: '2층',
            values: [280, 295, 267, 298, 345, 290, 275]
          },
          {
            name: '3층',
            values: [350, 368, 345, 380, 412, 365, 340]
          }
        ]
      },
      updateInterval: 3600
    }
  },
  
  dual_axis_line: {
    name: '이중 Y축 라인 차트',
    icon: '📊',
    description: '서로 다른 단위의 데이터를 이중 Y축으로 비교',
    template: {
      title: '주행거리 및 충전횟수 추이',
      description: '일별 주행거리와 충전횟수를 이중 Y축을 사용하여 동시에 표시합니다.',
      chart_options: {
        viz_type: 'line',
        showFrame: true,
        transparent: false,
        options: {
          axes: {
            x: '날짜',
            y: '주행거리(km)'
          },
          style: {
            colors: ['#5470c6', '#91cc75']
          },
          advanced: {
            showLegend: true,
            legendPosition: 'top',
            lineSmooth: false,
            dualYAxis: {
              primary: {
                name: '주행거리(km)',
                color: '#5470c6',
                min: null,
                max: null
              },
              secondary: {
                name: '충전횟수',
                color: '#91cc75',
                position: 'right',
                min: null,
                max: null
              }
            },
            secondaryAxisSeries: ['충전횟수'],
            showDataLabels: false,
            labelFormat: '{value}',
            labelPosition: 'top'
          }
        }
      },
      data_source: {
        type: 'sql',
        query: `SELECT date, series_name, value 
FROM (
  SELECT '2024-01-01' as date, '주행거리' as series_name, 120.5 as value
  UNION ALL SELECT '2024-01-01', '충전횟수', 3
  UNION ALL SELECT '2024-01-02', '주행거리', 145.2
  UNION ALL SELECT '2024-01-02', '충전횟수', 4
  UNION ALL SELECT '2024-01-03', '주행거리', 98.7
  UNION ALL SELECT '2024-01-03', '충전횟수', 2
  UNION ALL SELECT '2024-01-04', '주행거리', 167.3
  UNION ALL SELECT '2024-01-04', '충전횟수', 5
  UNION ALL SELECT '2024-01-05', '주행거리', 134.8
  UNION ALL SELECT '2024-01-05', '충전횟수', 3
  UNION ALL SELECT '2024-01-06', '주행거리', 156.1
  UNION ALL SELECT '2024-01-06', '충전횟수', 4
  UNION ALL SELECT '2024-01-07', '주행거리', 112.4
  UNION ALL SELECT '2024-01-07', '충전횟수', 2
) AS t
ORDER BY date, series_name`
      },
      data_result: {
        categories: ['2024-01-01', '2024-01-02', '2024-01-03', '2024-01-04', '2024-01-05', '2024-01-06', '2024-01-07'],
        series: [
          {
            name: '주행거리',
            values: [120.5, 145.2, 98.7, 167.3, 134.8, 156.1, 112.4]
          },
          {
            name: '충전횟수',
            values: [3, 4, 2, 5, 3, 4, 2],
            useSecondaryAxis: true
          }
        ]
      },
      updateInterval: 3600
    }
  },
  
  stacked_bar: {
    name: '누적 막대 차트',
    icon: '📚',
    description: '여러 데이터를 누적하여 전체 비율 표시',
    template: {
      title: '월별 에너지원별 사용량',
      description: '에너지원별 사용량을 누적하여 전체 사용량과 구성 비율을 함께 표시합니다.',
      chart_options: {
        viz_type: 'bar',
        showFrame: true,
        transparent: false,
        options: {
          axes: {
            x: '월',
            y: '사용량 (kWh)'
          },
          style: {
            colors: ['#5470c6', '#91cc75', '#fac858', '#ee6666']
          },
          advanced: {
            stacked: true,
            showLegend: true,
            legendPosition: 'right'
          }
        }
      },
      data_source: {
        type: 'sql',
        query: `SELECT month, energy_source, usage 
FROM (
  SELECT '1월' as month, '태양광' as energy_source, 320 as usage
  UNION ALL SELECT '1월', 'ESS', 180
  UNION ALL SELECT '1월', '계통전력', 150
  UNION ALL SELECT '1월', '풍력', 80
  UNION ALL SELECT '2월', '태양광', 350
  UNION ALL SELECT '2월', 'ESS', 200
  UNION ALL SELECT '2월', '계통전력', 130
  UNION ALL SELECT '2월', '풍력', 90
  UNION ALL SELECT '3월', '태양광', 380
  UNION ALL SELECT '3월', 'ESS', 210
  UNION ALL SELECT '3월', '계통전력', 120
  UNION ALL SELECT '3월', '풍력', 100
  UNION ALL SELECT '4월', '태양광', 400
  UNION ALL SELECT '4월', 'ESS', 220
  UNION ALL SELECT '4월', '계통전력', 110
  UNION ALL SELECT '4월', '풍력', 110
  UNION ALL SELECT '5월', '태양광', 420
  UNION ALL SELECT '5월', 'ESS', 230
  UNION ALL SELECT '5월', '계통전력', 100
  UNION ALL SELECT '5월', '풍력', 120
  UNION ALL SELECT '6월', '태양광', 390
  UNION ALL SELECT '6월', 'ESS', 215
  UNION ALL SELECT '6월', '계통전력', 125
  UNION ALL SELECT '6월', '풍력', 105
) AS t
ORDER BY 
  CASE month 
    WHEN '1월' THEN 1
    WHEN '2월' THEN 2
    WHEN '3월' THEN 3
    WHEN '4월' THEN 4
    WHEN '5월' THEN 5
    WHEN '6월' THEN 6
  END, energy_source`
      },
      data_result: {
        categories: ['1월', '2월', '3월', '4월', '5월', '6월'],
        series: [
          {
            name: '태양광',
            values: [320, 350, 380, 400, 420, 390]
          },
          {
            name: 'ESS',
            values: [180, 200, 210, 220, 230, 215]
          },
          {
            name: '계통전력',
            values: [150, 130, 120, 110, 100, 125]
          },
          {
            name: '풍력',
            values: [80, 90, 100, 110, 120, 105]
          }
        ]
      },
      updateInterval: 3600
    }
  },
  
  pie: {
    name: '파이 차트',
    icon: '🥧',
    description: '전체 대비 비율을 보여주는 차트',
    template: {
      title: '에너지원별 사용 비율',
      description: '전체 에너지 사용량 중 각 에너지원이 차지하는 비율을 시각화합니다.',
      chart_options: {
        viz_type: 'pie',
        showFrame: true,
        transparent: false,
        options: {
          style: {
            colors: ['#5470c6', '#91cc75', '#fac858', '#ee6666', '#73c0de']
          },
          advanced: {
            showDataLabels: false,
            labelFormat: '{name}: {value}{unit} ({percent}%)',
            labelPosition: 'outside'
          }
        }
      },
      data_source: {
        type: 'sql',
        query: `SELECT source, amount 
FROM (
  VALUES 
    ('태양광', 1048),
    ('ESS', 735),
    ('계통전력', 580),
    ('풍력', 484),
    ('기타', 300)
) AS t(source, amount)`
      },
      data_result: {
        categories: ['태양광', 'ESS', '계통전력', '풍력', '기타'],
        series: [{
          name: '에너지원',
          values: [1048, 735, 580, 484, 300]
        }]
      },
      updateInterval: 3600
    }
  },
  
  
  heatmap: {
    name: '히트맵',
    icon: '🔥',
    description: '색상으로 데이터 강도를 표현',
    template: {
      title: '시간대별 전력 사용 패턴',
      description: '요일과 시간대별 전력 사용량을 색상 강도로 표현합니다. 사용 패턴을 한눈에 파악할 수 있습니다.',
      chart_options: {
        viz_type: 'heatmap',
        showFrame: true,
        transparent: false,
        options: {
          axes: {
            x: '요일',
            y: '시간대'
          },
          advanced: {
            min: 0,
            max: 100,
            showValueLabels: true,
            showDataLabels: false,
            labelFormat: '{value}'
          }
        }
      },
      data_source: {
        type: 'sql',
        query: `SELECT day_of_week, hour_range, usage 
FROM (
  VALUES 
    ('Mon', '00-06', 10), ('Mon', '06-12', 45), ('Mon', '12-18', 88), ('Mon', '18-24', 34),
    ('Tue', '00-06', 23), ('Tue', '06-12', 67), ('Tue', '12-18', 91), ('Tue', '18-24', 45),
    ('Wed', '00-06', 34), ('Wed', '06-12', 78), ('Wed', '12-18', 95), ('Wed', '18-24', 56),
    ('Thu', '00-06', 45), ('Thu', '06-12', 89), ('Thu', '12-18', 100), ('Thu', '18-24', 67),
    ('Fri', '00-06', 56), ('Fri', '06-12', 91), ('Fri', '12-18', 87), ('Fri', '18-24', 78),
    ('Sat', '00-06', 12), ('Sat', '06-12', 34), ('Sat', '12-18', 56), ('Sat', '18-24', 23),
    ('Sun', '00-06', 8), ('Sun', '06-12', 23), ('Sun', '12-18', 45), ('Sun', '18-24', 19)
) AS t(day_of_week, hour_range, usage)`
      },
      data_result: {
        categories: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
        series: [
          { name: '00-06시', values: [12, 23, 34, 45, 56, 12, 8] },
          { name: '06-12시', values: [45, 67, 78, 89, 91, 34, 23] },
          { name: '12-18시', values: [89, 91, 95, 100, 87, 56, 45] },
          { name: '18-24시', values: [34, 45, 56, 67, 78, 23, 19] }
        ]
      },
      updateInterval: 3600
    }
  },
  
  scatter: {
    name: '산점도',
    icon: '⚫',
    description: '두 변수 간의 관계를 점으로 표현',
    template: {
      title: '온도 vs 효율',
      description: '온도와 효율의 상관관계를 점으로 표시합니다. 두 변수 간의 관계를 분석할 수 있습니다.',
      chart_options: {
        viz_type: 'scatter',
        showFrame: true,
        transparent: false,
        options: {
          axes: {
            x: '온도 (°C)',
            y: '효율 (%)'
          },
          style: {
            colors: ['#fc8452']
          },
          advanced: {
            showDataLabels: false,
            labelFormat: '({x}, {y})',
            labelPosition: 'top'
          }
        }
      },
      data_source: {
        type: 'sql',
        query: `SELECT temperature, efficiency 
FROM (
  VALUES 
    (10, 92), (15, 94), (20, 96), (25, 95),
    (30, 93), (35, 89), (40, 85), (12, 93),
    (18, 95), (22, 96), (28, 94), (33, 91),
    (38, 87), (14, 94), (19, 95), (24, 95)
) AS t(temperature, efficiency)`
      },
      data_result: {
        categories: [],
        series: [{
          name: '온도-효율',
          values: [[10, 92], [15, 94], [20, 96], [25, 95], [30, 93], [35, 89], [40, 85], [12, 93], [18, 95], [22, 96], [28, 94], [33, 91], [38, 87], [14, 94], [19, 95], [24, 95]]
        }]
      },
      updateInterval: 3600
    }
  },
  
  gauge: {
    name: '계기판 게이지',
    icon: '⏱️',
    description: '시계바늘 형태로 현재 값을 표현',
    template: {
      title: '현재 SOC',
      description: '현재 배터리 충전 상태를 계기판 형태로 표시합니다. 실시간 상태를 직관적으로 확인할 수 있습니다.',
      chart_options: {
        viz_type: 'gauge',
        showFrame: true,
        transparent: false,
        options: {
          advanced: {
            min: 0,
            max: 100,
            unit: '%',
            radius: '75%',
            splitNumber: 10,
            detailFontSize: 24
          },
          style: {
            colors: ['#58D9F9']
          }
        }
      },
      data_source: {
        type: 'sql',
        query: "SELECT 75 AS value"  // 단일 값 반환 (별칭 필수)
      },
      data_result: {
        categories: [],
        series: [{
          name: '현재 SOC',
          values: [75]
        }]
      },
      updateInterval: 3600
    }
  },
  
  progress_bar: {
    name: '프로그레스바',
    icon: '🎯',
    description: '진행률을 색상 단계로 표현하는 게이지',
    template: {
      title: '배터리 충전 상태',
      description: '충전 진행률을 색상 단계로 구분하여 표시합니다. 위험/주의/정상 상태를 색상으로 구분합니다.',
      chart_options: {
        viz_type: 'progress_bar',  // 프로그레스 바 타입
        showFrame: false,
        transparent: true,
        options: {
          unit: '%',
          min: 0,
          max: 100,
          colorSteps: [
            [0.2, '#ff4d4f'],  // 0-20%: 빨간색 (위험)
            [0.4, '#faad14'],  // 20-40%: 주황색 (주의)
            [0.6, '#fadb14'],  // 40-60%: 노란색 (보통)
            [0.8, '#52c41a'],  // 60-80%: 연두색 (양호)
            [1, '#52c41a']     // 80-100%: 녹색 (우수)
          ],
          advanced: {
            min: 0,
            max: 100,
            unit: '%',
            radius: '75%',
            splitNumber: 10,
            detailFontSize: 32,
            axisLineWidth: 20,
            showPointer: true,
            showProgress: true,
            showDetail: true,
            barHeight: 18,  // 기본 바 높이 (px)
            barHeightPercentage: 100,  // 바 높이 퍼센트 (기본값의 100%)
            showScale: false,  // 눈금 표시 여부
            showDetails: false,  // 상태 텍스트 표시 여부
            borderRadius: 15,  // 바 모서리 반경
            showDescriptionTooltip: true  // description 툴팁 표시 여부
          },
          style: {
            fonts: {
              title: {
                fontSize: 20,
                fontWeight: '600',
                color: '#2c3e50'
              },
              value: {
                fontSize: 13,
                fontWeight: 'bold',
                color: 'auto'
              }
            }
          }
        }
      },
      data_source: {
        type: 'sql',
        query: "SELECT 91 AS value"  // 단일 값 반환
      },
      data_result: {
        categories: [],
        series: [{
          name: '',
          values: [91]
        }]
      },
      updateInterval: 3600
    }
  },
  
  radar: {
    name: '레이더 차트',
    icon: '📡',
    description: '다차원 데이터를 방사형으로 표현',
    template: {
      title: '성능 지표',
      description: '여러 성능 지표를 방사형 그래프로 표시합니다. 시스템 간 성능을 다차원으로 비교할 수 있습니다.',
      chart_options: {
        viz_type: 'radar',
        showFrame: true,
        transparent: false,
        options: {
          style: {
            colors: ['#5470c6', '#91cc75']
          },
          advanced: {
            showDataLabels: false,
            labelFormat: '{seriesName}: {value}',
            labelPosition: 'top',
            manualNormalization: false,
            normalizationMin: 0,
            normalizationMax: 100
          }
        }
      },
      data_source: {
        type: 'sql',
        query: `SELECT metric, series_name, value 
FROM (
  VALUES 
    ('효율성', 'System A', 85),
    ('안정성', 'System A', 90),
    ('용량', 'System A', 75),
    ('수명', 'System A', 80),
    ('온도', 'System A', 88),
    ('효율성', 'System B', 78),
    ('안정성', 'System B', 85),
    ('용량', 'System B', 82),
    ('수명', 'System B', 88),
    ('온도', 'System B', 76)
) AS t(metric, series_name, value)`
      },
      data_result: {
        categories: ['효율성', '안정성', '용량', '수명', '온도'],
        series: [
          { name: 'System A', values: [85, 90, 75, 80, 88] },
          { name: 'System B', values: [78, 85, 82, 88, 76] }
        ]
      },
      updateInterval: 3600
    }
  },
  
  
  text_label: {
    name: '텍스트 라벨',
    icon: '📝',
    description: '단일 값이나 텍스트를 크게 표시',
    template: {
      title: '현재 발전량',
      description: '중요한 수치나 텍스트를 크게 표시합니다. 핵심 지표를 강조할 때 사용합니다.',
      chart_options: {
        viz_type: 'text_label',
        showFrame: false,
        transparent: true,
        options: {
          content: '1,234 kWh',  // text_label은 content 사용
          fontSize: '48px',
          fontWeight: 'bold',
          textColor: '#2ecc71',
          textAlign: 'center'
        }
      },
      data_source: {
        type: 'static',
        content: '1,234 kWh'  // text_label은 static 데이터 사용 가능
      },
      data_result: {
        categories: [],
        series: []
      },
      updateInterval: 3600
    }
  },
  
  badge: {
    name: '배지',
    icon: '🏷️',
    description: '상태를 색상과 함께 표시',
    template: {
      title: '시스템 상태',
      description: '현재 상태값을 배지 형태로 표시합니다. 알림 조건에 따라 색상이 자동으로 변경됩니다.',
      chart_options: {
        viz_type: 'badge',
        showFrame: false,  // badge는 기본적으로 프레임 없음
        transparent: false,
        options: {
          showTitle: false,  // badge는 보통 타이틀 없음
          advanced: {
            badgeStyle: 'rounded',
            badgeColor: '#27ae60',
            textColor: '#ffffff',
            fontSize: 48,
            detailFontSize: 16,
            showGradient: true,
            showShadow: true,
            unit: '',
            alertCondition: 'value > 80',  // 경고 조건
            criticalCondition: 'value > 90'  // 심각 조건
          }
        }
      },
      data_source: {
        type: 'sql',
        query: "SELECT 75 AS value"  // 단일 숫자 값
      },
      data_result: {
        categories: [],
        series: []
      },
      updateInterval: 3600
    }
  },
  
  table: {
    name: '테이블',
    icon: '📊',
    description: '데이터를 표 형식으로 표시',
    template: {
      title: '배터리 상태 목록',
      description: '여러 항목의 상세 정보를 표 형식으로 표시합니다. 정렬과 필터링이 가능합니다.',
      chart_options: {
        viz_type: 'table',
        showFrame: true,
        transparent: false,
        options: {
          advanced: {
            alertColumn: 'soc',  // 알람 평가할 커럼
            alertCondition: 'value < 30',  // 경고 조건
            criticalCondition: 'value < 10',  // 심각 조건
            tableOptions: {
              showHeader: true,           // 헤더 표시 여부
              showRowBorders: true,       // 행 구분선 표시
              showColumnBorders: true,    // 열 구분선 표시
              showOuterBorder: true,      // 외곽 테두리 표시
              stripedRows: true,          // 줄무늬 효과
              hoverEffect: true,          // 호버 효과
              compactMode: false          // 컴팩트 모드
            }
          },
          style: {
            headerBackground: '#f5f5f5',
            headerColor: '#333333',
            rowBackground: '#ffffff',
            rowAlternateBackground: '#fafafa'
          }
        }
      },
      data_source: {
        type: 'sql',
        query: `SELECT 
  id AS "번호",
  name AS "배터리명",
  soc AS "SOC (%)",
  status AS "상태"
FROM (
  VALUES 
    (1, 'Battery-01', 85, '충전중'),
    (2, 'Battery-02', 72, '방전중'),
    (3, 'Battery-03', 90, '대기'),
    (4, 'Battery-04', 45, '충전중'),
    (5, 'Battery-05', 68, '방전중')
) AS t(id, name, soc, status)
ORDER BY id`
      },
      data_result: {
        columns: ['번호', '배터리명', 'SOC (%)', '상태'],
        rows: [
          [1, 'Battery-01', 85, '충전중'],
          [2, 'Battery-02', 72, '방전중'],
          [3, 'Battery-03', 90, '대기'],
          [4, 'Battery-04', 45, '충전중'],
          [5, 'Battery-05', 68, '방전중']
        ]
      },
      updateInterval: 3600
    }
  },
  
  battery_grid: {
    name: '배터리 그리드',
    icon: '🔋',
    description: '배터리 상태를 그리드로 표시',
    template: {
      title: '배터리 현황',
      description: '여러 배터리의 상태를 그리드 형태로 한눈에 모니터링합니다. 각 셀의 색상으로 상태를 표시합니다.',
      chart_options: {
        viz_type: 'battery_grid',
        showFrame: true,
        transparent: false,
        options: {
          advanced: {
            gridColumns: 6,
            gridRows: 4,
            cellType: 2,
            lastRowAlignment: 'center'
          }
        }
      },
      data_source: {
        type: 'sql',
        query: `SELECT batt_id, soc, soh, batt_state 
FROM (
  VALUES 
    ('BATT_01', 85, 95, 'normal'),
    ('BATT_02', 72, 88, 'normal'),
    ('BATT_03', 45, 82, 'warning'),
    ('BATT_04', 92, 91, 'normal'),
    ('BATT_05', 68, 85, 'normal'),
    ('BATT_06', 55, 79, 'normal'),
    ('BATT_07', 78, 93, 'normal'),
    ('BATT_08', 15, 75, 'critical'),
    ('BATT_09', 88, 96, 'normal'),
    ('BATT_10', 62, 87, 'normal')
) AS t(batt_id, soc, soh, batt_state)`
      },
      data_result: {
        categories: [],
        series: []
      },
      updateInterval: 3600
    }
  },
  
  navermap: {
    name: '네이버 지도',
    icon: '🗺️',
    description: '위치 정보를 지도에 표시',
    template: {
      title: '위치 현황',
      description: '위치 정보를 지도상에 마커로 표시합니다. 지리적 분포를 시각화할 수 있습니다.',
      chart_options: {
        viz_type: 'navermap',
        showFrame: true,
        transparent: false,
        options: {
          center: {
            lat: 37.5665,
            lng: 126.9780
          },
          zoom: 13,
          markers: [
            { lat: 37.5665, lng: 126.9780, title: '서울시청' },
            { lat: 37.5636, lng: 126.9869, title: '덕수궁' },
            { lat: 37.5729, lng: 126.9793, title: '경복궁' }
          ]
        }
      },
      data_source: {
        type: 'sql',
        query: `SELECT latitude, longitude, location_name 
FROM (
  VALUES 
    (37.5665, 126.9780, '서울시청'),
    (37.5636, 126.9869, '덕수궁'),
    (37.5729, 126.9793, '경복궁')
) AS t(latitude, longitude, location_name)`
      },
      data_result: {
        categories: [],
        series: []
      },
      updateInterval: 3600
    }
  },
  
  webframe: {
    name: '웹 프레임',
    icon: '🌐',
    description: '외부 웹페이지 표시',
    template: {
      title: '',
      description: '외부 웹페이지나 콘텐츠를 iframe으로 임베드합니다.',
      chart_options: {
        viz_type: 'webframe',
        showFrame: true,
        transparent: false,
        options: {
          height: '600px',
          aspectRatio: '16/9',
          showBorder: true,
          sandbox: 'allow-scripts allow-same-origin',
          loading: 'lazy'
        }
      },
      data_source: {
        type: 'static',
        url: 'https://www.example.com',  // webframe은 static URL 사용
        sso_config: {
          enabled: false,
          method: 'hash',  // 'query' | 'hash' (해시 방식 권장)
          param_name: 'auth_token'
        },
        query_params: []  // [{ param_name, variable_name, default_value }]
      },
      data_result: {
        categories: [],
        series: []
      },
      updateInterval: 0  // webframe은 자동 업데이트 불필요
    }
  },
  
  date_picker: {
    name: '날짜 선택기',
    icon: '📅',
    description: '날짜 범위를 선택하여 다른 차트에 변수 전달',
    template: {
      title: '조회 기간',
      description: '날짜 범위를 선택하여 다른 차트의 데이터 조회 기간을 제어합니다.',
      viz_type: 'date_picker',
      chart_options: {
        viz_type: 'date_picker',
        showFrame: false,  // 프레임 숨기기
        transparent: true,  // 투명 배경
        options: {
          title: '조회 기간',  // 공통 옵션
          advanced: {
            mode: 'range',  // 'single' | 'range'
            dateFormat: 'yyyy-MM-dd',
            showTime: false,
            timeFormat: 'HH:mm',
            defaultRange: 'last_7_days',  // 'today', 'yesterday', 'last_7_days', 'last_30_days', 'this_month', 'this_year'
            showQuickButtons: true,
            presetButtons: {
              today: true,
              yesterday: true,
              last7Days: true,
              last30Days: true,
              thisMonth: true,
              thisYear: true
            },
            inputFieldWidth: 'auto',  // 입력 필드 너비 (auto 또는 100-400px)
            minDate: null,  // 최소 선택 가능 날짜
            maxDate: null,  // 최대 선택 가능 날짜
            placeholder: {
              single: '날짜를 선택하세요',
              range: '날짜 범위를 선택하세요'
            },
            inline: false,  // true일 경우 인라인 캘린더로 표시
            debug: false    // 디버그 정보 표시 여부
          },
          style: {
            fonts: {
              title: {
                fontSize: 16,
                fontWeight: '600',
                color: '#333333'
              },
              value: {
                fontSize: 14,
                color: '#333333'
              },
              buttonText: {
                fontSize: 13,
                color: '#657786'
              }
            }
          }
        }
      },
      data_source: {
        type: 'static'  // date_picker는 SQL 쿼리 불필요
      },
      // 날짜 선택 시 다른 차트에서 사용할 수 있는 변수를 발행합니다
      // 내부적으로는 onChange/onCalendarClose 이벤트에서 처리되지만
      // 템플릿 시스템의 일관성을 위해 on_click 인터페이스를 사용합니다
      on_click: {
        publish: {
          // 날짜 변수 (showTime 옵션에 따라 시간 포함 여부 결정)
          startDate: '$event.startDate',      // 시작 날짜 (YYYY-MM-DD 형식)
          endDate: '$event.endDate',          // 종료 날짜 (YYYY-MM-DD 형식, range 모드만)
          startTime: '$event.startTime',      // 시작 시간 (HH:mm 형식, showTime=true일 때)
          endTime: '$event.endTime',          // 종료 시간 (HH:mm 형식, range 모드에서 showTime=true일 때)
          
          // 사용 예시:
          // 다른 차트의 SQL에서 ${startDate}, ${endDate} 형태로 사용 가능
          // WHERE date BETWEEN '${startDate}' AND '${endDate}'
          // WHERE datetime BETWEEN '${startDate} ${startTime}' AND '${endDate} ${endTime}'
        }
      },
      data_result: {
        categories: [],
        series: []
      },
      updateInterval: 0  // date_picker는 자동 업데이트 불필요
    }
  }
};

// 차트 타입별 아이콘 매핑 (UI에서 사용)
export const getChartIcon = (chartType) => {
  return chartTemplates[chartType]?.icon || '📊';
};

// 차트 타입별 이름 가져오기
export const getChartName = (chartType) => {
  return chartTemplates[chartType]?.name || chartType;
};

// 차트 타입별 설명 가져오기
export const getChartDescription = (chartType) => {
  return chartTemplates[chartType]?.description || '';
};

// 차트 템플릿 생성 함수
export const generateChartTemplate = (chartType, customTitle = null) => {
  const template = chartTemplates[chartType];
  if (!template) {
    console.error(`Unknown chart type: ${chartType}`);
    return null;
  }
  
  // 템플릿 복사본 생성 (원본 수정 방지)
  const generatedTemplate = JSON.parse(JSON.stringify(template.template));
  
  // 고유 ID 생성
  generatedTemplate.id = `chart_${chartType}_${Date.now()}`;
  
  // 사용자 정의 제목이 있으면 적용
  if (customTitle) {
    generatedTemplate.title = customTitle;
  }
  
  // 기본 위치 설정 (대시보드에서 자동 배치하도록)
  generatedTemplate.position = {
    x: 0,
    y: 0,
    w: chartType === 'text_label' || chartType === 'badge' ? 2 : 4,
    h: chartType === 'text_label' || chartType === 'badge' ? 2 : 4
  };
  
  return generatedTemplate;
};